export default "__VITE_ASSET__BOkwjTsM__"